import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import useInView from "../../hooks/useInView";

const CallToAction = () => {
  const [ctaRef, ctaInView] = useInView();

  return (
    <section ref={ctaRef} className="py-24 bg-white">
      <div
        className={`max-w-7xl mx-auto px-6 lg:px-12 transition-all duration-700 ${
          ctaInView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
        }`}
      >
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Events CTA */}
          <div className="relative rounded-2xl overflow-hidden group">
            <img
              src="/images/events.jpg"
              alt="Events at Willow Ridge"
              className="w-full h-80 object-cover group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#1B2A4A]/90 via-[#1B2A4A]/40 to-transparent flex flex-col justify-end p-8">
              <h3 className="text-3xl font-serif font-bold text-white mb-2">
                Host Your Event
              </h3>
              <p className="text-white/70 mb-6">
                Elegant spaces for 30-200 guests with full-service catering.
              </p>
              <Link
                to="/events"
                className="inline-flex items-center gap-2 text-[#C9A96E] font-medium hover:gap-3 transition-all duration-300"
              >
                View Events <ArrowRight size={18} />
              </Link>
            </div>
          </div>

          {/* Dining CTA */}
          <div className="relative rounded-2xl overflow-hidden group">
            <img
              src="/images/dining2.jpg"
              alt="Dining at Willow Ridge"
              className="w-full h-80 object-cover group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#1B2A4A]/90 via-[#1B2A4A]/40 to-transparent flex flex-col justify-end p-8">
              <h3 className="text-3xl font-serif font-bold text-white mb-2">
                Pub & Grill
              </h3>
              <p className="text-white/70 mb-6">
                Enjoy great food and drinks with stunning course views.
              </p>
              <Link
                to="/pub-grill"
                className="inline-flex items-center gap-2 text-[#C9A96E] font-medium hover:gap-3 transition-all duration-300"
              >
                View Menu <ArrowRight size={18} />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export { CallToAction };
